import { NavigateFunction } from 'react-router-dom';
import { FrontEndType } from 'components/common/types/Deal.types';
import { beginDealViewSwitch } from 'utils/dealSwitchView';

const dealPath = (id?: string): string => (id ? `/deal/${id}` : '/deal');

const plannerPath = (id?: string): string => (id ? `/planner/programmatic/${id}` : '/planner/programmatic');

type SwitchDealViewArgs = {
  isBlocked: boolean;
  isPlanner: boolean;
  id?: string;
  navigate: NavigateFunction;
  openModal: () => void;
};

const switchDealView = ({ isBlocked, isPlanner, id, navigate, openModal }: SwitchDealViewArgs): void => {
  if (isBlocked) {
    openModal();
    return;
  }
  beginDealViewSwitch();

  if (!isPlanner) {
    localStorage.setItem('preference', 'planner');
    navigate(plannerPath(id));
    return;
  }

  localStorage.removeItem('preference');
  navigate(dealPath(id));
};

type SwitchViewArgs = SwitchDealViewArgs & {
  frontEndType: FrontEndType;
  onChangeFrontEndType: (frontEndType: FrontEndType) => void;
};

export const switchView = ({
  isBlocked,
  isPlanner,
  id,
  navigate,
  openModal,
  frontEndType,
  onChangeFrontEndType,
}: SwitchViewArgs): void => {
  switchDealView({ isBlocked, isPlanner, id, navigate, openModal });

  if (isBlocked) return;

  const nextType = localStorage.getItem('preference') === 'planner' ? FrontEndType.PLANNER : FrontEndType.STANDARD;

  if (frontEndType !== nextType) onChangeFrontEndType(nextType);
};
